import { Header, Table } from 'semantic-ui-react';
import { Popup, Icon } from '@plone/volto/components';
import infoSVG from '@plone/volto/icons/info.svg';


export function AcousticFrequencies({ acoustic }){ 
    if (acoustic === undefined ){
        return ['63Hz', '125Hz', '250Hz', '500Hz', '1kHz', '2kHz', '4kHz', '8kHz'];
    }
    else if (acoustic?.items.filter((item) => item?.identifier == 'Generated Noise').length){
        return ['63Hz', '125Hz', '250Hz', '500Hz', '1kHz', '2kHz', '4kHz', '8kHz'];
    } else {
        return ['125Hz', '250Hz', '500Hz', '1kHz', '2kHz', '4kHz', '8kHz'];
    }
}


export function AcousticPopup(){
    return (<Popup trigger={<span className="info"><Icon className="infoicon" name={infoSVG} size="20px" /></span>} >
        <div>Legend:<ul><li><strong>Highest Performance</strong></li><li><strong className="code3db">Within 3dB (typically acceptable)</strong></li><li><strong className="code4db">Deficient by more than 3dB</strong></li></ul></div>
            </Popup>)
}


export function AcousticHighlight({value, best, performance, units=''}){
  let classname = "code4db";
  if ( value >= performance ) {
      classname = "";
  } else if ( value >= performance - 3 ) {
      classname = "code3db";
  }
  if ( value === best ){ 
      return (<strong className={ 'best ' + classname }>{ value }{units}</strong>);
  } else { 
      return (<span className={ classname }>{ value }{units}</span>);
  }
}


export function Acoustic({ calculator, highlight }){
    const searchParams = new URLSearchParams(document.location.search)
    if (searchParams.get('debug')) {
        console.log("Acoustic", calculator);
        console.log(calculator?.acoustic?.items.filter((item) => item?.identifier == 'Generated Noise').length);
    }
    const columns = AcousticFrequencies({acoustic: calculator?.acoustic} );
    if ( calculator?.acoustic?.items.length > 0 ){
        return (
                    <>
                    <Header sub>Acoustic Performance</Header>

                    <Table className="acoustic">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Frequency</Table.HeaderCell>
                                      { calculator?.acoustic?.items.map((item) => (
                                      <Table.HeaderCell key={item["identifier"]}>{ item['identifier'] } (dB) 
                                          {(item['identifier'] === 'Insertion Loss' && highlight !== undefined ) && <AcousticPopup/>}
                                      </Table.HeaderCell> 
                                      ))}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {columns.map((column) => (
                                  <Table.Row key={column}>
                                    <Table.Cell key={column}>{ column }</Table.Cell> 
                                      { calculator?.acoustic?.items.map((item, index) => (
                                      <Table.Cell key={ column + '_' + index }>
                                          {( item['identifier'] === 'Insertion Loss' ) ? 
                                        <AcousticHighlight value={item[column]} best={calculator?.submittal?.acoustic_max?.[column]} performance={calculator?.submittal?.acoustic_insertion?.[column] | 0.0 } />
                                          : ( item[column] ) }
                                      </Table.Cell> 
                                      ))}
                                  </Table.Row>
                                 ))}
                        </Table.Body>
                    </Table>
                    </>
      )
    } else { return null;
 }
}
